if (!customElements.get('color-swatches')) {
customElements.define('color-swatches', class ColorSwatches extends HTMLElement {
    constructor() {
      super();
  
      this.swatches = this.querySelectorAll("[js-swatch-color]");
    }

    connectedCallback() {
        this.init()
    }

    init() {
        const swatchItems = this.querySelectorAll(".product-color-swatch");
if (swatchItems.length <= 1) {
  const wrapper = this.closest(".price_right_new");
  if (wrapper) wrapper.style.display = "none";
  return;
}
        this.swatches.forEach( swatchEl => {
            const swatch = (window.swatchesData || []).find( swatch => swatch.name === swatchEl.getAttribute("data-color"));
            if(!swatch) return;

            swatchEl.style.backgroundColor = swatch.color;
            swatch.image ? swatchEl.style.backgroundImage = `url(${swatch.image})` : null;
        });

        if(this.getAttribute("is") === "product-stitcher") return;

        $(this).find("[js-data-variant-image]").hover(function() {
            var featured_image_new = $(this).attr("data-first-image");
            var hover_image_new = $(this).attr("data-second-image");
            if(featured_image_new)
            {
                $(this).parents(".card-wrapper").find(".featured_image_new").attr("src",featured_image_new);
            }
            if(hover_image_new)
            {
                $(this).parents(".card-wrapper").find(".hover_image_new").attr("src",hover_image_new);
            }
        })
    }
});
}
